<template>
    <div class="max-w-container w-full mx-auto">
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>